const trackingDataFixture = (overrides) => {
  const defaults = {
    order: {
      id: 'US-123456789',
      number: 'US-123456789',
      revenue: 0,
      tax: 0,
      shipping: 0,
      product_skus: [],
      product_slugs: [],
    },
    products: [],
  };

  return { ...defaults, ...overrides };
};

export { trackingDataFixture };
